import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import {
  BrowserModule,
  HAMMER_GESTURE_CONFIG,
} from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PortalComponent } from './portal/portal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HttpClientModule } from '@angular/common/http';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { appReducers } from './store';
import { BreakpointObserverService } from './service/mobile-resize.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

//design system
import {
  WInputModule,
  SnackBarDefaultModule,
  WbaButtonModule,
} from '@wbatd/design-system-wba';

import { RecebiveisComponent } from './modules/recebiveis/recebiveis.component';
import { MenuAppComponent } from './components/menu-app/menu-app.component';
import { MenuInternasPaginaComponent } from './components/menu-internas-pagina/menu-internas-pagina.component';
import { PanelMenuComponent } from './components/panel-menu/panel-menu.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatMenuModule } from '@angular/material/menu';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { initializer } from './init/keycloak-init.factory';
import { AuthGuard } from './guards/auth.guard';
import { AuthService } from './service/auth.service';
import { DemoService } from './service/demo.service';
import { VisaoCedenteSacadoComponent } from './components/visao-cedente-sacado/visao-cedente-sacado.component';
import { SharedModule } from './modules/shared/shared.module';
import { CedenteGuard } from './guards/cedente.guard';
import { SacadoGuard } from './guards/sacado.guard';
import { ProfileService } from './service/profile.service';
import localePT from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';

registerLocaleData(localePT);
import { OperacionalComponent } from './modules/operacional/operacional.component';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomPaginator } from './utils/geral';
import { MatTooltipModule } from '@angular/material/tooltip';
import {WebSocketService} from "./service/web-socket.service";

@NgModule({
  declarations: [
    AppComponent,
    PortalComponent,
    RecebiveisComponent,
    MenuAppComponent,
    MenuInternasPaginaComponent,
    PanelMenuComponent,
    VisaoCedenteSacadoComponent,
    OperacionalComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    WInputModule,
    WbaButtonModule,
    SnackBarDefaultModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    NgxSpinnerModule,
    BrowserAnimationsModule,
    MatMenuModule,
    FontAwesomeModule,
    MatSnackBarModule,
    KeycloakAngularModule,
    SharedModule,
    StoreModule.forRoot(appReducers),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
    }),
    MatTooltipModule,
  ],
  providers: [
    CookieService,
    BreakpointObserverService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializer,
      multi: true,
      deps: [KeycloakService],
    },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: MatPaginatorIntl, useValue: CustomPaginator() },
    AuthGuard,
    CedenteGuard,
    SacadoGuard,
    AuthService,
    ProfileService,
    DemoService,
    WebSocketService
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
